import React from 'react';
import { Form, Upload, Icon } from 'antd';
import validateFile from '../../../../helpers/validateFile';

const UploadDragger = ({
  label,
  fileList,
  setState,
  onlyPicture = false,
  iconProps,
  description = '',
  colon = false,
}) => {
  const handleBeforeUpload = (file) => {
    const validated = validateFile(file, { onlyPicture });

    if (!validated) {
      return false;
    }

    setState((list) => {
      return [...list, file];
    });

    return false;
  };

  const handleRemove = (file) => {
    const index = fileList.indexOf(file);
    const newFileList = fileList.slice();
    newFileList.splice(index, 1);
    setState(newFileList);
  };

  return (
    <Form.Item label={label} colon={colon}>
      <Upload.Dragger
        name="file"
        height={54}
        fileList={fileList}
        multiple
        beforeUpload={handleBeforeUpload}
        onRemove={handleRemove}
      >
        <Icon {...iconProps} /> {description}
      </Upload.Dragger>
    </Form.Item>
  );
};

export default UploadDragger;
